import { CheckCheck, ListChecks, UsersRound, X } from "lucide-react";

import { Button } from "../ui/button";

// O que fazer com as conversas marcadas.
//
// Existia o um (botão da linha) e o todos (botão da barra), e nada no meio —
// que é justamente o caso comum: encerrar as seis conversas do mesmo assunto,
// passar as quatro de um atendente que saiu. A barra só aparece com algo
// marcado; sem seleção ela não rouba espaço da lista.
const BarraDeSelecao = ({
  quantidade,
  total,
  aoSelecionarTodos,
  aoLimpar,
  aoResolver,
  aoTransferir,
  podeResolver,
  podeTransferir,
}) => {
  if (!quantidade) return null;

  return (
    <div className="flex shrink-0 flex-wrap items-center gap-2 border-t bg-primary/5 px-3 py-1.5">
      <span className="text-xs font-semibold tabular-nums">
        {quantidade} selecionada{quantidade > 1 ? "s" : ""}
      </span>

      {/* "Todas" é o que está carregado na lista, não o que existe no
          servidor: prometer o segundo e agir sobre o primeiro seria mentir.
          Para a lista inteira existe o "Resolver todos" da barra de cima. */}
      {quantidade < total && (
        <Button
          size="sm"
          variant="ghost"
          className="h-7 px-2 text-xs"
          onClick={aoSelecionarTodos}
        >
          <CheckCheck className="h-3.5 w-3.5" />
          Selecionar as {total} visíveis
        </Button>
      )}

      <span className="ml-auto flex items-center gap-1">
        {podeResolver && (
          <Button
            size="sm"
            variant="outline"
            className="h-7 px-2 text-xs"
            onClick={aoResolver}
          >
            <ListChecks className="h-3.5 w-3.5 text-emerald-600 dark:text-emerald-400" />
            Resolver
          </Button>
        )}

        {podeTransferir && (
          <Button
            size="sm"
            variant="outline"
            className="h-7 px-2 text-xs"
            onClick={aoTransferir}
          >
            <UsersRound className="h-3.5 w-3.5 text-sky-600 dark:text-sky-400" />
            Transferir
          </Button>
        )}

        <Button
          size="sm"
          variant="ghost"
          className="h-7 px-2 text-xs"
          onClick={aoLimpar}
          title="Limpar seleção"
        >
          <X className="h-3.5 w-3.5" />
        </Button>
      </span>
    </div>
  );
};

export default BarraDeSelecao;
